export const SET_WRAPPER_ORIGIN = 'SET_WRAPPER_ORIGIN'
export const SET_WRAPPER_DEVICE_TYPE = 'SET_WRAPPER_DEVICE_TYPE'
export const SET_WRAPPER_RECIPE_SCHEMA_ITEMS = 'SET_WRAPPER_RECIPE_SCHEMA_ITEMS'
export const SET_WRAPPER_CURRENT_URL = 'SET_WRAPPER_CURRENT_URL'
